module.exports = __webpack_public_path__ + "static/media/66.90412ce5.jpg";